import { render, staticRenderFns } from "./AddNumber.modal.vue?vue&type=template&id=24338b02&"
import script from "./AddNumber.modal.vue?vue&type=script&lang=js&"
export * from "./AddNumber.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports